/* ========= FRAGS · Hero GSAP — Igual al HTML original ========= */
(function () {
  var $  = (s, r) => (r || document).querySelector(s);

  var section = $('.section--frags-hero .frags-hero') || $('.frags-hero');
  if (!section) return;

  /* ---- Carga de librerías ---- */
  function loadScript(src){
    return new Promise(function (resolve, reject){
      if (document.querySelector('script[src="'+src+'"]')) return resolve();
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  function ensureLibs(){
    var gsapSrc = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
    var stSrc   = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';
    var tspSrc  = 'https://cdn.jsdelivr.net/npm/tsparticles@2/tsparticles.bundle.min.js';
    return loadScript(gsapSrc)
      .then(() => loadScript(stSrc))
      .then(() => { if (window.gsap && window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger); })
      .then(() => loadScript(tspSrc))
      .catch(() => {});
  }

  /* ---- Pin spacer negro (evita “flash” al fijar) ---- */
  function paintPinSpacer(){
    var spacer = section.closest('.pin-spacer') ||
                 (section.parentElement && section.parentElement.classList.contains('pin-spacer') ? section.parentElement : null);
    if (spacer){
      spacer.style.background = '#0a0a0a';
      spacer.classList.add('frags-pin-bg');
      spacer.style.zIndex = '0';
    }
  }

  /* ---- Partículas (exactas al HTML) ---- */
  function initParticles(){
    if (!window.tsParticles) return;
    var host = section.querySelector('.frags-particles');
    if (!host) return;
    tsParticles.load({
      id: host.id || ('frags-particles-' + (section.getAttribute('data-section-id') || '0')),
      options: {
        detectRetina: true,
        background: { color: { value: 'transparent' } },
        particles: {
          number: { value: parseInt(section.getAttribute('data-particles') || '90', 10), density: { enable:true, area:800 } },
          color:  { value: ['#c9a227', '#e8d4a0', '#ffffff'] },
          shape:  { type: 'circle' },
          opacity:{ value: { min:0.1, max:0.5 }, animation: { enable:true, speed:0.5, minimumValue:0.1, sync:false } },
          size:   { value: { min:1,   max:3   }, animation: { enable:true, speed:2.0, minimumValue:0.5, sync:false } },
          move:   { enable:true, speed:0.5, direction:'none', outModes:{ default:'out' }, straight:false, random:true },
          links:  { enable:false }
        },
        interactivity: { detectsOn:'window', events:{ onHover:{enable:false}, onClick:{enable:false}, resize:true } },
        fullScreen: { enable:false }
      }
    });
  }

  /* ---- Animación GSAP (parámetros y tiempos calcados) ---- */
  function initAnimations(){
    var gsap = window.gsap, ScrollTrigger = window.ScrollTrigger;
    if (!gsap || !ScrollTrigger) return;

    var wrap   = section.querySelector('.frags-bottles');
    var left   = section.querySelector('.frags-bottle--left');
    var center = section.querySelector('.frags-bottle--center');
    var right  = section.querySelector('.frags-bottle--right');
    var text   = section.querySelector('.frags-hero__text');
    var scrollEl = section.querySelector('.frags-scroll');

    // Idle float igual al HTML
    if (wrap) gsap.to(wrap, { y:-20, duration:2.5, ease:'sine.inOut', repeat:-1, yoyo:true });

    // Colocar las botellas exactamente en el centro real
    function setBottlesAtCenter(){
      if (!wrap) return;
      var r = wrap.getBoundingClientRect();
      var cx = r.width/2;
      gsap.set([left, center, right], { position:'absolute', top:0, left:cx, xPercent:-50, yPercent:0, clearProps:'x' });
      gsap.set([left, right], { opacity:0, rotation:0 });
      gsap.set(center, { opacity:1, scale:1 });
    }
    ScrollTrigger.addEventListener('refreshInit', setBottlesAtCenter);
    window.addEventListener('resize', setBottlesAtCenter, { passive:true });

function buildTimeline(cfg){
  var wrap   = section.querySelector('.frags-bottles');
  var left   = section.querySelector('.frags-bottle--left');
  var center = section.querySelector('.frags-bottle--center');
  var right  = section.querySelector('.frags-bottle--right');
  var text   = section.querySelector('.frags-hero__text');
  var scrollEl = section.querySelector('.frags-scroll');

  var offset    = cfg.offset ?? 250;          // = HTML
  var end       = cfg.end    ?? '+=150%';     // = HTML
  var lrOpacity = cfg.leftRightOpacity ?? 0.6;
  var cScale    = cfg.centerScale ?? 1.1;
  var tScale    = cfg.textScale   ?? 1.15;
  var tY        = cfg.textY       ?? 30;

  // coloca botellas en el centro real del wrap
  function setBottlesAtCenter(){
    if (!wrap) return;
    var r = wrap.getBoundingClientRect();
    var cx = r.width/2;
    gsap.set([left, center, right], { position:'absolute', top:0, left:cx, xPercent:-50, yPercent:0, clearProps:'x' });
    gsap.set([left, right], { opacity:0, rotation:0 });
    gsap.set(center, { opacity:1, scale:1 });
  }
  setBottlesAtCenter();

  // usamos valores FUNCIONALES + invalidateOnRefresh para recalcular en cada refresh
  var tl = gsap.timeline({
    scrollTrigger:{
      trigger: section,
      start: 'top top',
      end: end,
      scrub: 1,
      pin: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      onRefresh: setBottlesAtCenter
    }
  });

  // ancho/centro siempre recalculados
  var cx = () => (wrap ? wrap.getBoundingClientRect().width / 2 : 0);

  if (left)  tl.to(left,  { opacity: lrOpacity, left: () => cx() - offset, rotation:-15, duration:1.0, ease:'power1.out' }, 0);
  if (right) tl.to(right, { opacity: lrOpacity, left: () => cx() + offset, rotation: 15, duration:1.0, ease:'power1.out' }, 0);
  if (center)tl.to(center,{ scale: cScale, duration:1.2, ease:'power2.out' }, 0.2);

  // el texto empieza a desvanecer desde el segundo 0 (como en el HTML)
  if (text)  tl.to(text, { scale: tScale, y: tY, opacity: 0, duration: 2.0, ease:'none' }, 0);

  if (scrollEl) tl.to(scrollEl, { opacity: 0, duration: 0.3, ease:'none' }, 0);

  return tl;
}


    var mm = gsap.matchMedia();
    // Desktop
    mm.add('(min-width: 769px)', () => buildTimeline({
      offset: 250, end: '+=150%', leftRightOpacity: 0.6, centerScale: 1.1, textScale: 1.15, textY: 30
    }));
    // Mobile
    mm.add('(max-width: 768px)', () => buildTimeline({
      offset: 140, end: '+=90%', leftRightOpacity: 1.0, centerScale: 1.08, textScale: 1.08, textY: 20
    }));
  }

  /* ---- Boot ---- */
  ensureLibs().then(function(){
    initParticles();
    initAnimations();
    window.addEventListener('resize', function(){
      if (window.ScrollTrigger) setTimeout(()=> ScrollTrigger.refresh(), 60);
    }, { passive:true });
    window.addEventListener('load', function(){
      if (window.ScrollTrigger) setTimeout(()=> ScrollTrigger.refresh(), 60);
    }, { passive:true });
  });
})();
